import React, { useEffect, useState } from "react";
import { fetchAllMessagesAPI } from "../../../services/messages_history";
import DeleteConfirmation from "../../../components/DeleteConfirmation";
import { deleteMessageAPI } from "../../../services/message";

const MessagesHistory = () => {
    const [messages, setMessages] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState(null);

    const fetchDataFromApi = async () => {
        try {
            const responseData = await fetchAllMessagesAPI();
            console.log({ responseData });
            setMessages(responseData.data);
        } catch (error) {
            setError(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchDataFromApi();
    }, []);

    if (error) {
        return <div>Error: {error.message}</div>;
    }

    const formatDate = (inputDate) => {
        const date = new Date(inputDate);

        const months = ["Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];

        const year = date.getFullYear();
        const month = months[date.getMonth()];
        const day = date.getDate();

        let hours = date.getHours();
        const minutes = date.getMinutes();

        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        const minutesStr = minutes < 10 ? "0" + minutes : minutes; // adding leading zero if needed

        const formattedDate = `${month} ${day}, ${year} @ ${hours}:${minutesStr} ${ampm}`;

        return formattedDate;
    };

    const toggleDeletePopup = (id) => {
        setSelectedMessage(id);
        setIsDeleteOpen(!isDeleteOpen);
    };



    return (
        <div>
            {isLoading ? (
                <div className="flex justify-center mt-10">
                    <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-10 w-10 opacity-90"></div>
                </div>
            ) : (
                <div>
                    {messages && messages.length > 0 ? (
                        <>
                            <div className="w-full flex justify-end">
                                <div className="py-5 flex gap-3 px-5"></div>
                            </div>

                            <div className="px-5">
                                <table className="min-w-full divide-y bg-back-dark divide-color-lines rounded-lg">
                                    <thead className="min-w-full rounded-md divide-color-lines">
                                        <tr>
                                            <th scope="col" className="px-6 py-3 text-left text-sm text-slate-400 font-medium tracking-wider whitespace-nowrap">
                                                Date
                                            </th>
                                            <th scope="col" className="px-6 py-3 text-center text-sm text-slate-400 font-medium tracking-wider whitespace-nowrap">
                                                From
                                            </th>
                                            <th scope="col" className="px-6 py-3 text-center text-sm text-slate-400 font-medium tracking-wider whitespace-nowrap">
                                                To
                                            </th>
                                            <th scope="col" className="px-6 py-3 text-center text-sm text-slate-400 font-medium tracking-wider whitespace-nowrap">
                                                Message Type
                                            </th>
                                            <th scope="col" className="px-6 py-3 text-center text-sm text-slate-400 font-medium tracking-wider whitespace-nowrap">
                                                Text
                                            </th>

                                            <th scope="col" className="px-6 py-3 text-center text-sm text-slate-400 font-medium tracking-wider whitespace-nowrap">

                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-back-dark divide-y divide-color-lines">
                                        {messages.map((call) => (
                                            <tr key={call.id} className="hover:bg-gray-900 text-sm">
                                                <td className="px-6 py-4 whitespace-wrap">{formatDate(call.createdAt)}</td>
                                                <td className="px-6 py-4 whitespace-wrap text-center">{call.fromPhone}</td>
                                                <td className="px-6 py-4 whitespace-wrap text-center">{call.toPhone}</td>
                                                <td className="px-6 py-4 whitespace-wrap text-center">{call.messageType}</td>
                                                <td className="px-6 py-4 whitespace-wrap text-center">{call.messageText}</td>
                                                <td className="px-6 py-4 whitespace-wrap text-center">
                                                    <button className="text-white bg-red-700 hover:bg-red-800 focus:ring-4  font-medium rounded-lg text-sm px-3  py-2  dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800" type="button"
                                                        onClick={() => toggleDeletePopup(call.id)}
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    ) : (
                        <div className="flex items-center justify-center text-center text-xl pt-10">
                            <div>No Messages found.</div>
                        </div>
                    )}
                </div>
            )}
            {selectedMessage && <DeleteConfirmation isOpen={isDeleteOpen} onClose={toggleDeletePopup} title={"Are you sure, you want to delete this message?"} id={selectedMessage} fetchDataFromApi={fetchDataFromApi} deleteMethod={deleteMessageAPI} />}
        </div>
    );
};

export default MessagesHistory;
